// src/components/AlertaUrgente.js
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "./AlertaUrgente.css";

function AlertaUrgente() {
  const [mensagem, setMensagem] = useState("");
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const alertaFechado = sessionStorage.getItem("alertaFechado");
    if (alertaFechado === "true") return;

    async function buscarAlerta() {
      try {
        const ref = doc(db, "configuracaoGeral", "alertaUrgente");
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const dados = snap.data();
          if (dados.alertaAtivo && dados.mensagem) {
            setMensagem(dados.mensagem);
            setVisivel(true);
          }
        }
      } catch (err) {
        console.error("Erro ao buscar alerta urgente:", err);
      }
    }

    buscarAlerta();
  }, []);

  function fecharAlerta() {
    setVisivel(false);
    sessionStorage.setItem("alertaFechado", "true");
  }

  if (!visivel) return null;

  return (
    <div className="alerta-urgente">
    <div className="alerta-conteudo">
      <span className="mensagem-alerta">{mensagem}</span>
    </div>
  </div>
  );
}

export default AlertaUrgente;